export default "/assets/website/images/simplepay-payments.png?5282e902bb4d011f48619732dda6f353";